export * from './angularfire2';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/~/angularfire2/public_api.js
// module id = ../../../../angularfire2/public_api.js
// module chunks = 3